import { render } from "./Inputs.vue?vue&type=template&id=1783d007&scoped=true&bindings={\"maxRange\":\"data\",\"minRange\":\"data\",\"location\":\"data\",\"handleButtonClick\":\"options\",\"locations\":\"props\"}"
import script from "./Inputs.vue?vue&type=script&lang=js"
export * from "./Inputs.vue?vue&type=script&lang=js"

import "./Inputs.vue?vue&type=style&index=0&id=1783d007&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1783d007"

export default script